import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class Header {

  private header: HTMLElement = document.querySelector('header.js-l-header');

  constructor(private $log: Logger, private $utils: Utils) {
    window.addEventListener('resize', () => {
      this.initHeaderHeight();
    });

    window.addEventListener('scroll', () => {
      this.setHeaderTopClass();
      this.initHeaderHeight();
    }, {passive: true});

    this.setHeaderTopClass();
    this.initHeaderHeight();
  }

  private initHeaderHeight(): void {
    const headerHeight = this.header?.clientHeight;

    document.body.style.setProperty('--headerHeight', `${headerHeight ?? 0}px`);
  }

  private setHeaderTopClass() {
    if (window.scrollY === 0) {
      this.$utils.addOrRemoveClases('add', 'top', this.header);
      this.$utils.addOrRemoveClases('add', 'top', document.body);
    } else {
      this.$utils.addOrRemoveClases('remove', 'top', this.header);
      this.$utils.addOrRemoveClases('remove', 'top', document.body);
    }
  }
}
